<route>
{
  "name": "chapterEdit",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="formData.name">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.course"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="select"
        :items="courseList"
        item-text="name"
        item-value="_id"
        icon="mdi-cards-variant"
        :label="$t('pages.forms.typeSelectLabel')"
      ></form-item>
      <form-item
        v-model="formData.name"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="2"
        icon="mdi-form-textbox"
        :label="$t('models.name')"
        :placeholder="$t('models.name')"
      ></form-item>
      <form-item
        v-model="formData.description"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="6"
        icon="mdi-form-textbox"
        :label="$t('models.description')"
        :placeholder="$t('models.description')"
      ></form-item>
      <form-item
        v-model="formData.order"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="number"
        icon="mdi-form-textbox"
        :label="$t('models.order')"
        :placeholder="$t('models.order')"
      ></form-item>
      <form-item
        v-model="formData.image"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.image')"
        :placeholder="$t('models.image')"
      ></form-item>
      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
        <removeConfirm
          @success="remove"
          @cancel="removeConfirmDialog = false"
          v-model="removeConfirmDialog"/>
        <v-btn
          class="mr-auto"
          @click="removeConfirmDialog = true"
          color="error"
        >
          {{ $t('pages.forms.removeButtonText') }}
        </v-btn>
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    removeConfirmDialog: false,
    formIsValid: true,
    courseList: [],
    formData: {
      name: '',
      description: '',
      image: 'image',
      course: null,
      order: 0
    }
  }),
  computed: {
  },
  created () {
    this.preLoadData()
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('chapter/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.formData = response.data        
      })
      this.$store.dispatch('course/getCourses').then((response) => {
        this.courseList = response.data
      })
    },
    update () {
      this.$store.dispatch('chapter/update', {
        id: this.$route.params.id,
        course: this.formData.course.$oid,
        name: this.formData.name,
        description: this.formData.description,
        order: this.formData.order,
        image: this.formData.image,
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    remove () {
      this.removeConfirmDialog = false
      this.$store.dispatch('chapter/remove', {
        id: this.$route.params.id
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    // NOTE: Keep this name same in all form pages and components
    onSubmitForm () {
      this.update()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
